import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef, Fragment } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import i18n from 'i18next';
import moment from 'moment';
import $ from 'jquery';
import { TablePagination } from '@material-ui/core';
import ModalDialog from './ui/modal-dialog';
import DateRange from './ui/react-ui/date-range';
import DataTable from './ui/table';
import Progress from './ui/react-ui/progress.jsx'; // api

import { getAuditLogTotalStatistics, getAuditLogStatistics } from '../api/auditLogStatisticsAPI';
var gt = i18n.getFixedT(null, 'app');
export var AuditLogStatisticsSearch = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      dialogInfo = _useSelector.service.dialogInfo;

  var onClose = props.onClose;
  var initDateTime = {
    from: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD')
  };

  var _useState = useState(initDateTime),
      _useState2 = _slicedToArray(_useState, 2),
      dateTime = _useState2[0],
      setDateTime = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      totalCount = _useState6[0],
      setTotalCount = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      tableData = _useState10[0],
      setTableData = _useState10[1];

  var _useState11 = useState({
    field: 'statisticDate',
    desc: true
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      tableSort = _useState12[0],
      setTableSort = _useState12[1];

  var _useState13 = useState({
    websiteCount: 0,
    managementCount: 0,
    appCount: 0
  }),
      _useState14 = _slicedToArray(_useState13, 2),
      totalStatistics = _useState14[0],
      setTotalStatistics = _useState14[1];

  var isMounted = useRef(false);
  var actions = {};

  _.set(actions, 'export', {
    text: gt('global.lbl-export'),
    className: 'button-secondary',
    handler: function handler() {
      handleExportCSV();
    }
  });

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: onClose
  });

  var handleChangePage = function handleChangePage(e, newPage) {
    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleChangeDateTime = function handleChangeDateTime(dateTime) {
    setDateTime(dateTime);
  };

  var handleSort = function handleSort(sort) {
    setTableSort(sort);
  };

  var handleExportCSV = function handleExportCSV() {
    $.ajax({
      url: "".concat(contextRoot, "/audit-log-statistics/export"),
      method: 'GET',
      beforeSend: function beforeSend(xhr) {
        Progress.startSpin();
      },
      data: {
        start: dateTime.from,
        end: dateTime.to,
        sort: tableSort.field + ':' + (tableSort.desc ? 'desc' : 'asc')
      },
      xhrFields: {
        responseType: 'blob'
      },
      success: function success(data) {
        var a = document.createElement('a');
        a.style.display = 'none';
        a.href = window.URL.createObjectURL(data);
        a.setAttribute('download', "login_count_".concat(dateTime.from, "-").concat(dateTime.to, ".xlsx"));
        a.click();
        document.body.appendChild(a);
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
        Progress.done();
      }
    });
  };

  var fetchData = function fetchData() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getAuditLogStatistics(contextRoot, false, dateTime, tableSort, 0, 50).then(function (result) {
      var map = new Map();
      var resultData;

      if (result.content.length > 0) {
        resultData = result.content.filter(function (el) {
          if (map.has(moment(el.statisticDate).valueOf())) return false;
          map.set(moment(el.statisticDate).valueOf());
          return true;
        });
      }

      var totalElements = resultData.length;
      resultData = resultData.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage);

      var newData = _.map(resultData, function (el, index) {
        return _objectSpread(_objectSpread({}, el), {}, {
          sequence: offset + index + 1
        });
      });

      setTableData(newData);
      setTotalCount(totalElements);
      setTotalStatistics({
        websiteCount: result.value.websiteCount,
        managementCount: result.value.managementCount,
        appCount: result.value.appCount,
        totalCount: result.value.totalCount
      });
    });
  };

  useEffect(function () {
    if (!isMounted.current) return;
    fetchData();
  }, [JSON.stringify(tableSort), currentPage, rowsPerPage]);
  useEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
      fetchData();
    }
  }, []);
  var fields = {};

  _.set(fields, 'statisticDate', {
    label: gt('auditLogStatistics.lbl-statistic-date'),
    sortable: true
  });

  _.set(fields, 'websiteCount', {
    label: gt('auditLogStatistics.lbl-website-count'),
    sortable: true
  });

  _.set(fields, 'managementCount', {
    label: gt('auditLogStatistics.lbl-management-count'),
    sortable: true
  });

  _.set(fields, 'appCount', {
    label: gt('auditLogStatistics.lbl-app-count'),
    sortable: true
  });

  _.set(fields, 'totalCount', {
    label: gt('auditLogStatistics.lbl-total-count'),
    sortable: false
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: "g-audit-log-statistics-search",
    title: gt('auditLogStatistics.title'),
    global: true,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "date-select"
  }, /*#__PURE__*/React.createElement(DateRange, {
    id: "datetime",
    enableStartEndLabel: true,
    startLabel: gt('auditLogStatistics.lbl-start-time'),
    endLabel: gt('auditLogStatistics.lbl-end-time'),
    onChange: handleChangeDateTime,
    value: dateTime,
    limitRange: '30d'
  }), /*#__PURE__*/React.createElement("button", {
    className: "button",
    onClick: function onClick() {
      return fetchData();
    }
  }, gt('global.lbl-search'))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: tableSort,
    onSort: handleSort
  })), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer-item-label"
  }, gt('auditLogStatistics.lbl-table-foolter-website-count')), /*#__PURE__*/React.createElement("div", {
    className: "footer-item-value"
  }, totalStatistics.websiteCount)), /*#__PURE__*/React.createElement("div", {
    className: "footer-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer-item-label"
  }, gt('auditLogStatistics.lbl-table-foolter-management-count')), /*#__PURE__*/React.createElement("div", {
    className: "footer-item-value"
  }, totalStatistics.managementCount)), /*#__PURE__*/React.createElement("div", {
    className: "footer-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer-item-label"
  }, gt('auditLogStatistics.lbl-table-foolter-app-count')), /*#__PURE__*/React.createElement("div", {
    className: "footer-item-value"
  }, totalStatistics.appCount)), /*#__PURE__*/React.createElement("div", {
    className: "footer-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer-item-label"
  }, gt('auditLogStatistics.lbl-table-foolter-total-count')), /*#__PURE__*/React.createElement("div", {
    className: "footer-item-value"
  }, totalStatistics.totalCount))), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('auditLogStatistics.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })));
});
export var AuditLogStatistics = /*#__PURE__*/React.memo(function (props) {
  var id = props.id,
      onClick = props.onClick;

  var _useSelector2 = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector2.envCfg.contextRoot;

  var _useState15 = useState({
    websiteCount: 0,
    managementCount: 0,
    appCount: 0
  }),
      _useState16 = _slicedToArray(_useState15, 2),
      totalStatistics = _useState16[0],
      setTotalStatistics = _useState16[1];

  var isMounted = useRef(false);
  useEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
      fetchData();
    }
  }, []);

  var fetchData = function fetchData() {
    getAuditLogTotalStatistics(contextRoot, true).then(function (result) {
      setTotalStatistics({
        websiteCount: result.value.websiteCount,
        managementCount: result.value.managementCount,
        appCount: result.value.appCount,
        totalCount: result.value.totalCount
      });
    });
  };

  var handleClick = function handleClick() {
    onClick();
  };

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: id,
    onClick: function onClick() {
      handleClick();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, gt('auditLogStatistics.title')), /*#__PURE__*/React.createElement("div", {
    className: "statistics"
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, gt('auditLogStatistics.website')), /*#__PURE__*/React.createElement("div", {
    className: "count"
  }, totalStatistics.websiteCount)), /*#__PURE__*/React.createElement("div", {
    className: "statistics"
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, gt('auditLogStatistics.management')), /*#__PURE__*/React.createElement("div", {
    className: "count"
  }, totalStatistics.managementCount)), /*#__PURE__*/React.createElement("div", {
    className: "statistics"
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, gt('auditLogStatistics.app')), /*#__PURE__*/React.createElement("div", {
    className: "count"
  }, totalStatistics.appCount)), /*#__PURE__*/React.createElement("div", {
    className: "statistics"
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, gt('auditLogStatistics.total')), /*#__PURE__*/React.createElement("div", {
    className: "count"
  }, totalStatistics.totalCount))));
});
AuditLogStatistics.defaultProps = {
  id: 'g-audit-log-statistics'
};
AuditLogStatistics.propTypes = {
  id: PropTypes.string
};